import { LayoutRouteContent } from './routeNode';
import { UnauthorizedAccessPageProps } from '@ardoq/manage-resource-permissions';

const defaultUnauthorizedAccess: UnauthorizedAccessPageProps = {
  message:
    'This page is only available to organization administrators. Please contact your administrator if you need access.',
};

export const adminBoundary =
  (
    unauthorizedAccess: UnauthorizedAccessPageProps = defaultUnauthorizedAccess
  ) =>
  async (): LayoutRouteContent =>
    (await import('./DeclarativeAdminBoundaryPage')).buildAdminBoundary(
      unauthorizedAccess
    );
